// import AppConstants from "../../../../../config/app.constants";
import TNTBillingBase from "../../util/TNTBillingBase";

class LocationDistanceController extends TNTBillingBase{
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state;
    this.acl = {};
    this.hasACL = {};
    this.id = 'location_distance'
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_billing_' + this.id]) {
        this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
    }
  }	
}

export default LocationDistanceController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/location_distance.controller.js